import React from 'react';
import PropTypes from 'prop-types';

const Toggle = ({ children, onClick, isOpen, className, title }) => (
  <div
    onClick={onClick}
    onKeyDown={onClick}
    className={className}
    role="button"
    tabIndex="-1"
    title={title}
  >
    {React.Children.map(children, (child) => {
      let p = {};
      if (child.type && child.type.name === 'Chevron') p = { ...p, isOpen };
      return React.cloneElement(child, p);
    })}
  </div>
);

Toggle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
};

Toggle.defaultProps = {
  onClick: undefined,
  isOpen: false,
  className: undefined,
  title: undefined,
};

export default Toggle;
